import { useMemo } from "react";
import { Group } from "three";
import FenceUnit from "../components/FenceUnit"; // her bir çit bölmesi (2 dikme + yatay paneller)
import FacingText from "../components/FacingText";


const Fence3D = ({ config }) => {
    const { sections = [], almColor, glassColor } = config;
    const groupRef = useMemo(() => new Group(), []);
    const scale = 0.003;

    let posX = 0, posZ = 0, angleSum = 0;

    return (
        <group ref={groupRef}>

            {sections.map((section, secIndex) => {
                const sectionHeight = parseFloat(section.size?.height || 0) * scale;
                const panelWidth = parseFloat(section.panels?.[0]?.width || 0) * scale;
                const angleRad = (angleSum * Math.PI) / 180;
                const dirX = -Math.cos(angleRad);
                const dirZ = -Math.sin(angleRad);
                const rotation = [0, -angleSum * (Math.PI / 180), 0];
                const panelOffsetX = posX + dirX * (panelWidth);
                const panelOffsetZ = posZ + dirZ * (panelWidth);
                const panelGap = config.panel_center_space * scale;
                const bottomSpace = config.panel_bottom_space * scale;

                // Yükseklik paylaştırması için toplam yükseklik-
                let unitHeight = 0;
                let yOffset = bottomSpace;
                let topLed = null;

                const group = (
                    <group
                        key={`section-${secIndex}`}
                        rotation={rotation}
                        position={[panelOffsetX, 0, panelOffsetZ]}
                    >
                        {section.panels.slice().reverse().map((panel, i) => {
                            if (section.panels.length === 2) {
                                if (i == 0) {
                                    unitHeight = config.bottom_panel_size;
                                    yOffset = 0;
                                    topLed = null;
                                } else {
                                    unitHeight = (section.size?.height - config.bottom_panel_size);
                                    yOffset = (config.bottom_panel_size) * scale - 0.05;
                                    topLed = config.kupeste_ust;
                                }
                            } else {
                                unitHeight = section.size?.height;
                                topLed = config.kupeste_ust;
                            }
                            unitHeight = unitHeight * scale;
                            const panelHeight = parseFloat(panel.height) * scale;
                            const panelCount = parseInt(panel.piece || 1);

                            return (
                                <FenceUnit
                                    index={i}
                                    key={`panel-${secIndex}-${i}`}
                                    width={panelWidth}
                                    height={unitHeight}
                                    panelHeight={panelHeight}
                                    panelGap={panelGap}
                                    bottomSpace={i == 0 ? bottomSpace : 0}
                                    almColor={almColor}
                                    glassColor={glassColor}
                                    position={[0, yOffset, 0]}
                                    panelCount={panelCount}
                                    caseled={config.led}
                                    topLed={topLed}
                                    angle={section.angle}
                                    category={panel.category}
                                    subCategory={panel.sub_category}
                                />
                            );
                        })}
                    </group>
                );

                posX += dirX * panelWidth;
                posZ += dirZ * panelWidth;

                if (section.angle > 0) {
                    angleSum += 180 - section.angle;
                }

                return group;
            })}
        </group>
    );
};

export default Fence3D;
